//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import { mapGetters,mapActions,mapState } from 'vuex';
// import { requestByPost } from '@/until/request'
// import { API } from '@/until/api'
// import { fnSub } from '../../until/base';
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import { Toast } from 'vant';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  name: 'cdrConvert',
  data () {
    let that = this
    return {
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      cdrFileInfo: {},
      schemeInfo: {
        appId: 'APP_XMPC',
        schemeOptions: []
      }, // 方案信息，父页面跳转时传入方案id，页面中通过方案id初始化方案信息
      appId: 'APP_XMPC',
      projectName: '',
      companyName: '',
      companyId: '',
      ccProdTypeId: '',
      ccProdTypeName: '',
      schemeOptions: [],
      fileList: [],
      // visible:false,
      value:'',
      shapeColumns: [],
      record:{},
      optionColumns,
      show:false,
      activeTop:1,
      cdr: 0,
      analysisShapeInfo: {
        analysisShapeInfos: []
      },
      DIV_WIDTH: 1200,
      DIV_HEIGHT: 450,
      SCAN: 1,
      divRec: null,
      gapX: 0,
      gapY: 0,
      dragObj: {},
      MAX_HEIGHT: 40,
      MIN_HEIGHT: 30,
      MAX_WIDTH: 200,
      defaultCdrFileName: 'demo.cdr',
      selectedRowKeys: [],
      selectedRows: [],
      hideShapes: [],
      requirement: "",
      defaultProduct: null,
      scroll: { x: 760 },
      cdrDemoPage: 0,
      caseInfoDemo: {
        // id: '2946f94d7b2d11ebbd399c5c8ebcfe65' // 测试
        id: '822edb65779011eb895400163e08070d' // 正式
      },
      cdrUrlHeader: this.$store.getters['cdr/getCdrImageUrlHeader'],
      locale: zhCN
    }
  },
  components:{
    Footer,
    Header
  },
  computed : {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
          this.selectedRowKeys = selectedRowKeys
          if (!selectedRowKeys || selectedRowKeys.length == 0) {
            this.fnClearSelectedShape()
          }
          // selectedRows.forEach(row => {
          //   row.selected = 1
          //   $$("#" + row.staticID).css({
          //     "border": "1px solid blue"
          //   })
          // })
        },
        onSelect: (row, checked) => {
          if (checked) {
            this.selectedRowKeys.push(row.staticID)
          } else {
            this.selectedRowKeys = [...this.selectedRowKeys.filter(key => key != row.staticID)]
          }
        },
        onSelectAll: (checked) => {
          this.selectedRowKeys = []
          if (checked) {
            this.analysisShapeInfo.analysisShapeInfos.forEach(shape => {
              this.selectedRowKeys.push(shape.staticID)
            })
          }
        },
        getCheckboxProps: record => ({
          props: {
            // defaultChecked: true
          }
        })
      }
    }
  },
  methods:{
    initSchemeInfo () {
        if (this.$route.params.schemeInfo) {
          this.schemeInfo = Object.assign(JSON.parse(this.$route.params.schemeInfo))
        } else {
          this.schemeInfo = JSON.parse(localStorage.getItem("schemeInfo"))
        }
        if (this.schemeInfo != null && this.schemeInfo.saasProjectId != null) {
          this.fnInitSchemeInfo()
        } else {
          this.cdrDemoPage = JSON.parse(localStorage.getItem("cdrDemoPage"))
          if (this.cdrDemoPage == 1) {
            this.$store.dispatch('company/getProjectInfoById', JSON.stringify(this.caseInfoDemo))
              .then((res)=>{
                var ccProjectInfoBo = res.data.obj;
                this.schemeInfo = {
                  saasProjectId: ccProjectInfoBo.saasProjectId, // 对应saas的方案id
                  saasFactoryId: ccProjectInfoBo.saasFactoryId,// 对应saas的工厂id
                  projectId: ccProjectInfoBo.id,// 平台方案id
                  ccProdTypeId: ccProjectInfoBo.ccProdTypeId,//分类id
                  ccProdTypeName: ccProjectInfoBo.prodTypeName,//分类name
                  projectName: ccProjectInfoBo.name,
                  companyName: ccProjectInfoBo.companyName,
                  companyId: ccProjectInfoBo.companyId
                }
                this.$nextTick(() => {
                  this.fnInitSchemeInfo()
                })
              })
          }
        }
    },
    fnInitSchemeInfo () {
      if (this.schemeInfo) {
        this.projectName = this.schemeInfo.projectName
        this.companyName = this.schemeInfo.companyName
        this.ccProdTypeId = this.schemeInfo.ccProdTypeId
        this.companyId = this.schemeInfo.companyId
        this.ccProdTypeName = this.schemeInfo.ccProdTypeName
        this.schemeInfo.schemeOptions= []
      }
      this.schemeInfo.appId = this.appId
      // console.log('initSchemeInfo schemeInfo ===>', this.schemeInfo)
      this.$store.dispatch('scheme/loadAiSchemeBySaasProjectId', this.schemeInfo)
        .then(res => {
          if (res.data && res.data.retCode == 1) {
            res.data.obj.aiSchemeProds.forEach(prod => {
              if (prod.isDefault) {
                prod.selected = 1
              } else {
                prod.selected = 0
              }
            })
            this.schemeInfo = Object.assign(res.data.obj)
            this.convertSchemeInfo()
            this.initShapeColumns()
            if (this.cdrDemoPage == 1) {
              this.$nextTick(() => {
                this.fnLoadCdrFileDemo()
              })
            }
          } else {
            // console.log('initSchemeInfo res===>', res)
            if (res.data.retMsg) {
              Toast(res.data.retMsg)
            } else {
              Toast('方案信息加载失败')
            }
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    convertSchemeInfo () {
      // console.log('this.schemeInfo===>', this.schemeInfo)
      this.schemeOptions = []
      this.schemeInfo.schemeOptions = []
      this.schemeInfo.productOptions = []
      this.schemeInfo.aiSchemeOptions.forEach(opt => {
        if (opt.type == 1) {
          // 产品选项 初始化表头
          this.schemeInfo.productOptions.push(JSON.parse(JSON.stringify(opt)))
        } else {
          // 方案选项
          var additions = JSON.parse(JSON.stringify(this.schemeInfo.aiSchemeOptionDetails.filter(detail => detail.optionId == opt.optionId)))
          additions.forEach(add => {
            if (add.isDefault == 1) {
              add.selected = 1
            } else {
              add.selected = 0
            }
          })
          opt.additions = [...additions]
          this.schemeInfo.schemeOptions.push(JSON.parse(JSON.stringify(opt)))
          this.schemeOptions = this.schemeInfo.schemeOptions
        }
      })
      this.schemeInfo.productOptions = this.schemeInfo.productOptions.sort((a, b) => {
        return a.optionType - b.optionType
      })
    },
    actTop(v){
      this.activeTop = v
      this.analysisShapeInfo.analysisShapeInfos.forEach(shape => {
        shape.sizeMult = this.activeTop
      })
    },
    fnLoadCdrFileDemo () {
      this.$store.dispatch('cdr/fnLoadCdrFileDemo', {})
        .then(res => {
          console.log('fnLoadCdrFileDemo res ===>', res)
          if (res.data.retCode == 1) {
            this.$nextTick(() => {
              this.fnDoAnalysis(res.data.obj)
            })
          }
        }).catch(err => {
          console.log("fnLoadCdrFileDemo err ===>", err)
        })
    },
    fnUploadCdrFile (files) {
      var formData = new FormData()
      const { file } = files
      formData.append('file', file)
      this.$store.dispatch('cdr/uploadCdrFile', formData)
        .then(res => {
          // console.log('fnUploadCdrFile res ===>', res)
          if (res.retCode == 1) {
            this.fnDoAnalysis(res.obj)
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    fnDoAnalysis (fileInfo) {
      this.cdrFileInfo = {
        cdrFilePath: fileInfo.cdrFilePath,
        outPath: fileInfo.outPath,
        cdrFileName: fileInfo.cdrFileName,
        cdrFilePathBak: fileInfo.cdrFilePathBak,
        cdrFileUrl:  fileInfo.cdrFileUrl,
        urlHeader: fileInfo.urlHeader
      };
      console.log('fnDoAnalysis this.cdrFileInfo===', this.cdrFileInfo)
      this.$store.dispatch('cdr/DoAnalysis', Object.assign(this.cdrFileInfo))
        .then(res => {
          console.log('fnDoAnalysis res===>', res)
          if (res.data && res.data.retCode == 1) {
            this.cdr = 1
            this.$nextTick(() => {
              this.fnInitCdrShapes(res.data)
            })
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    fnInitCdrShapes (res) {
      if (!this.divRec) {
        var rec = this.$refs.divImageShow.getBoundingClientRect()
        var offset = $$(".divImageShow").offset()
        this.divRec = {
          top: offset.top,
          left: offset.left,
          width: rec.width,
          height: rec.height
        }
      }
      if (res.obj.shapeWidth > this.DIV_WIDTH || res.obj.shapeHeight > this.DIV_HEIGHT) {
        this.fnInitDpiByShapeSize(res.obj.shapeWidth, res.obj.shapeHeight)
      }
      this.selectedRowKeys = []
      this.selectedRows = []
      res.obj.analysisShapeInfos.forEach(shapeInfo => {
        this.fnInitSingleShapeInfo(shapeInfo)
        this.selectedRowKeys.push(shapeInfo.staticID)
      })
      this.selectedRows = [...res.obj.analysisShapeInfos]
      this.fnSortShapeInfo(res.obj.analysisShapeInfos)
      this.analysisShapeInfo = res.obj
      this.analysisShapeInfo.width = parseFloat(this.analysisShapeInfo.shapeWidth / this.SCAN).toFixed(5)
      this.analysisShapeInfo.height = parseFloat(this.analysisShapeInfo.shapeHeight / this.SCAN).toFixed(5)
      this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
    },
    fnInitDpiByShapeSize (width, height) {
      var SCAN_X = width / this.DIV_WIDTH
      var SCAN_Y = height / this.DIV_HEIGHT
      if (SCAN_X > SCAN_Y) {
        this.SCAN = SCAN_X
      } else {
        this.SCAN = SCAN_Y
      }
    },
    fnInitSingleShapeInfo (shapeInfo) {
      var imgWidth = parseFloat(shapeInfo.shapeWidth / this.SCAN).toFixed(5)
      var imgHeight = parseFloat(shapeInfo.shapeHeight / this.SCAN).toFixed(5)
      if (!this.defaultProduct) {
        var defaultPro = this.schemeInfo.aiSchemeProds.find(content => content.isDefault == 1)
        if (!defaultPro) {
          this.defaultProduct = this.schemeInfo.aiSchemeProds[0]
        } else {
          this.defaultProduct = defaultPro
        }
      }
      shapeInfo.width = imgWidth
      shapeInfo.height = imgHeight
      shapeInfo.specWidth = shapeInfo.shapeWidth / 10
      shapeInfo.specHeight = shapeInfo.shapeHeight / 10
      shapeInfo.sizeMult = 1
      if (this.defaultProduct) {
        this.handleShapeProductChanged(this.defaultProduct, shapeInfo)
      } else {
        shapeInfo.productType = '-1'
        shapeInfo.productName = ''
        shapeInfo.additions = []
      }
    },
    fnInitShapeImageStyle (shapeInfo) {
      var positionX = parseFloat(((shapeInfo.leftx - this.analysisShapeInfo.leftx) / this.SCAN) + (this.divRec.width - this.analysisShapeInfo.width) / 2).toFixed(5)
			var positionY = parseFloat(((this.analysisShapeInfo.topy - shapeInfo.topy) / this.SCAN) + (this.divRec.height - this.analysisShapeInfo.height) / 2).toFixed(5)
      return 'borderColor: blue;width: ' + shapeInfo.width + 'px; height: ' + shapeInfo.height + 'px; top: ' + positionY + 'px;' + 'left: ' + positionX + 'px;';
    },
    fnInitTableImageStyle (shapeInfo) {
      var imgHeight, imgWidth
      if (shapeInfo.height > this.MAX_HEIGHT) {
        imgHeight = this.MAX_HEIGHT
      } else if (shapeInfo.height < this.MIN_HEIGHT) {
        imgHeight = this.MIN_HEIGHT
      } else {
        imgHeight = shapeInfo.height
      }
      imgWidth = shapeInfo.width * (imgHeight / shapeInfo.height)
      if (imgWidth > this.MAX_WIDTH) {
        imgHeight = imgHeight * (this.MAX_WIDTH / imgWidth)
        imgWidth = this.MAX_WIDTH
      }
      return 'width: ' + imgWidth + 'px;height: ' + imgHeight + 'px;'
    },
    fnGetDpi () {
      if (window.screen.deviceXDPI) {
				this.STATIC_DPI_X = window.screen.deviceXDPI;
				this.STATIC_DPI_Y = window.screen.deviceYDPI;
			} else {
				var tmpNode = document.createElement("DIV");
				tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
				document.body.appendChild(tmpNode);
				this.STATIC_DPI_X = parseInt(tmpNode.offsetWidth);
				this.STATIC_DPI_Y = parseInt(tmpNode.offsetHeight);
				tmpNode.parentNode.removeChild(tmpNode);
			}
      this.DPI_X = this.STATIC_DPI_X
      this.DPI_Y = this.STATIC_DPI_Y
      this.MAX_X = (this.DPI_X * this.DIV_WIDTH) / 25.4
      this.MAX_Y = (this.DPI_Y * this.DIV_HEIGHT) / 25.4
    },
    fnBtnClearClick () {
      this.cdr = 0
      this.cdrFileInfo = {}
      this.analysisShapeInfo = {
        analysisShapeInfos: []
      }
    },
    fnBtnResetClick () {
      if (this.cdr == 0) {
        Toast("请先上传CDR文件")
        return;
      }
      this.$store.dispatch('cdr/resetCdrFile', Object.assign(this.cdrFileInfo))
        .then(res => {
          // console.log('fnBtnResetClick res ===>', res)
          if (res.data && res.data.retCode == 1) {
            this.analysisShapeInfo = {
              analysisShapeInfos: []
            }
            this.$nextTick(() => {
              this.fnInitCdrShapes(res.data);
              this.fnSelectAllRows()
              this.fnClearSelectedShape()
            })
          } else {
            Toast(res.retMsg)
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },
    handleShapeImageClicked (e, analysisShape) {
      if (analysisShape.selected) {
        e.target.style.border = '0px solid blue'
        analysisShape.selected = 0
        // this.selectedRowKeys = this.selectedRowKeys.filter(key => key != analysisShape.staticID)
      } else {
        e.target.style.border = '1px solid blue'
        analysisShape.selected = 1
        // this.selectedRowKeys.push(analysisShape.staticID)
      }
    },
    // handleShowShapes () {
    //   var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
    //   if (selectedShapeInfos && selectedShapeInfos.length > 0) {
    //     selectedShapeInfos.forEach(shape => {
    //       if (shape.hide) {
    //         shape.hide = 0
    //         this.hideShapes.push(shape)
    //         this.analysisShapeInfo.analysisShapeInfos
    //         _.remove(this.analysisShapeInfo.analysisShapeInfos, shape)
    //       }
    //     })
    //   } else {
    //     Toast("请选择要设为可见的图形");
    //   }
    // },
    // handleHideShapes (e) {
    //   var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
    //   if (selectedShapeInfos && selectedShapeInfos.length > 0) {
    //     selectedShapeInfos.forEach(shape => {
    //       if (!shape.hide) {
    //         shape.hide = 1
    //         this.analysisShapeInfo.analysisShapeInfos.push(shape)
    //         _.remove(this.hideShapes, shape)
    //       }
    //     })
    //   } else {
    //     Toast("请选择要隐藏的图形");
    //   }
    // },
    handleGroupShapes () {
      var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
      if (selectedShapeInfos && selectedShapeInfos.length > 1) {
        var staticIDs = '';
        selectedShapeInfos.forEach((shape, index) => {
          if (index == 0) {
							staticIDs = shape.staticID;
						} else {
							staticIDs += "," + shape.staticID;
						}
        })
        this.cdrFileInfo.staticIDs = staticIDs
        this.$store.dispatch('cdr/groupShapes', Object.assign(this.cdrFileInfo))
          .then(res => {
            // console.log('handleGroupShapes res ===>', res)
            if (res.data && res.data.retCode == 1) {
              var lastShapes = this.analysisShapeInfo.analysisShapeInfos.filter(shape => {
                var sh = selectedShapeInfos.find(s => s.staticID == shape.staticID);
                if (sh) {
                  return false
                } else {
                  return true
                }
              })
              var newShape = res.data.obj
              this.fnInitSingleShapeInfo (newShape)
              lastShapes.push(newShape)
              this.fnSortShapeInfo(lastShapes)
              this.analysisShapeInfo.analysisShapeInfos = []
              this.analysisShapeInfo.analysisShapeInfos = [...lastShapes]
              this.$nextTick(() => {
                this.fnSelectAllRows()
                this.fnClearSelectedShape()
                this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
              })
            } else {
              Toast(res.retMsg)
            }
          }).catch(err => {
            console.log('err===>', err)
          })
      } else {
        Toast("请至少选择两个要组合的图形");
      }
    },
    handleCombineShapes () {
      var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
      if (selectedShapeInfos && selectedShapeInfos.length > 1) {
        var staticIDs = '';
        selectedShapeInfos.forEach((shape, index) => {
          if (index == 0) {
              staticIDs = shape.staticID;
            } else {
              staticIDs += "," + shape.staticID;
            }
        })
        this.cdrFileInfo.staticIDs = staticIDs
        this.$store.dispatch('cdr/combineShapes', Object.assign(this.cdrFileInfo))
          .then(res => {
            if (res.data && res.data.retCode == 1) {
              var lastShapes = this.analysisShapeInfo.analysisShapeInfos.filter(shape => shape.selected != 1)
              res.data.obj.selected = 1
              var newShape = res.data.obj
              this.fnInitSingleShapeInfo(newShape)
              lastShapes.push(newShape)
              this.fnSortShapeInfo(lastShapes)
              this.analysisShapeInfo.analysisShapeInfos = []
              this.analysisShapeInfo.analysisShapeInfos = [...lastShapes]
              this.$nextTick(() => {
                this.fnSelectAllRows()
                this.fnClearSelectedShape()
                this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
              })
            } else {
              Toast(res.retMsg)
            }
          }).catch(err => {
            console.log('err===>', err)
          })
      } else {
        Toast("请至少选择两个要结合的图形");
      }
    },
    handleConvertShapes () {
      var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
      if (selectedShapeInfos && selectedShapeInfos.length > 0) {
        var staticIDs = '';
        selectedShapeInfos.forEach((shape, index) => {
          if (index == 0) {
              staticIDs = shape.staticID;
            } else {
              staticIDs += "," + shape.staticID;
            }
        })
        this.cdrFileInfo.staticIDs = staticIDs
        this.$store.dispatch('cdr/convertToCurves', Object.assign(this.cdrFileInfo))
          .then(res => {
            if (res.data && res.data.retCode == 1) {
              var lastShapes = this.analysisShapeInfo.analysisShapeInfos.filter(shape => shape.selected != 1)
              res.data.obj.analysisShapeInfos.forEach(sh => {
                sh.selected = 1
                this.fnInitSingleShapeInfo(sh)
              })
              var newShapes = lastShapes.concat(res.data.obj.analysisShapeInfos);
              this.fnSortShapeInfo(newShapes)
              this.analysisShapeInfo.analysisShapeInfos = [...newShapes]
              this.$nextTick(() => {
                this.fnSelectAllRows()
                this.fnClearSelectedShape()
                this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
              })
            } else {
              Toast(res.retMsg)
            }
          }).catch(err => {
            console.log('err===>', err)
          })
      } else {
        Toast("请选择要转曲的图形");
      }
    },
    handleSmartCombineShapes () {
      var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
      if (selectedShapeInfos && selectedShapeInfos.length > 0) {
        var staticIDs = ''
        selectedShapeInfos.forEach((shape, index) => {
          if (index == 0) {
              staticIDs = shape.staticID
            } else {
              staticIDs += "," + shape.staticID
            }
        })
        this.cdrFileInfo.staticIDs = staticIDs
        this.$store.dispatch('cdr/smartCombine', Object.assign(this.cdrFileInfo))
          .then(res => {
            // console.log('handleSmartCombineShapes res ===>', res)
            if (res.data && res.data.retCode == 1) {
              var lastShapes = this.analysisShapeInfo.analysisShapeInfos.filter(shape => shape.selected != 1)
              res.data.obj.analysisShapeInfos.forEach(sh => {
                sh.selected = 1
                this.fnInitSingleShapeInfo(sh)
              })
              var newShapes = lastShapes.concat(res.data.obj.analysisShapeInfos)
              this.fnSortShapeInfo(newShapes)
              this.analysisShapeInfo.analysisShapeInfos = [...newShapes]
              this.$nextTick(() => {
                this.fnSelectAllRows()
                this.fnClearSelectedShape()
                this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
              })
            } else {
              Toast(res.retMsg)
            }
          }).catch(err => {
            console.log('err===>', err)
          })
      } else {
        Toast("请选择要智能结合的图形");
      }
    },
    handleBreakApartShapes () {
      var selectedShapeInfos = this.analysisShapeInfo.analysisShapeInfos.filter(el => el.selected == 1)
      if (selectedShapeInfos && selectedShapeInfos.length > 0) {
        var staticIDs = '';
        selectedShapeInfos.forEach((shape, index) => {
          if (index == 0) {
              staticIDs = shape.staticID;
            } else {
              staticIDs += "," + shape.staticID;
            }
        })
        this.cdrFileInfo.staticIDs = staticIDs
        this.$store.dispatch('cdr/breakApart', Object.assign(this.cdrFileInfo))
          .then(res => {
            if (res.data && res.data.retCode == 1) {
              var lastShapes = this.analysisShapeInfo.analysisShapeInfos.filter(shape => shape.selected != 1)
              res.data.obj.analysisShapeInfos.forEach(shape => {
                this.fnInitSingleShapeInfo(shape)
              })
              var concatShapes = lastShapes.concat(res.data.obj.analysisShapeInfos)
              this.fnSortShapeInfo(concatShapes)
              this.analysisShapeInfo.analysisShapeInfos = []
              this.analysisShapeInfo.analysisShapeInfos = [...concatShapes]
              this.$nextTick(() => {
                this.fnSelectAllRows()
                this.fnClearSelectedShape()
                this.$refs.shapeTable.pagination.total = this.analysisShapeInfo.analysisShapeInfos.length
              })
            } else {
              Toast(res.retMsg)
            }
          }).catch(err => {
            console.log('err===>', err)
          })
      } else {
        Toast("请选择要打散的图形");
      }
    },
    handleShapeProductChanged (prod, shapeInfo) {
      shapeInfo.productType = prod.saasProdId
      shapeInfo.productName = prod.productName
      shapeInfo.additions = []
      if (prod.aiSchemeProdOptonDetails) {
        var addtions = JSON.parse(JSON.stringify(prod.aiSchemeProdOptonDetails))
        addtions.forEach(add => {
          if (add.isDefault == 1) {
            add.selected = 1
          } else {
            add.selected = 0
          }
        })
        shapeInfo.additions = [...addtions]
      }
      var analysisShapeInfos = [...this.analysisShapeInfo.analysisShapeInfos]
      this.fnSortShapeInfo(analysisShapeInfos)
      this.analysisShapeInfo.analysisShapeInfos = []
      this.analysisShapeInfo.analysisShapeInfos = [...analysisShapeInfos]
    },
    fnSelectAllRows () {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.analysisShapeInfo.analysisShapeInfos.forEach(shape => {
        this.selectedRowKeys.push(shape.staticID)
      })
      this.selectedRows = [...this.analysisShapeInfo.analysisShapeInfos]
    },
    fnSortShapeInfo (shapes) {
      shapes.sort((a, b) => {
        if (a.bottomy > b.topy)
        {
          return -1;
        }
        else if (b.bottomy > a.topy)
        {
          return 1;
        }
        else {
          if (a.rightx < b.leftx)
          {
            return -1;
          }
          else if (a.leftx < b.leftx)
          {
            return -1;
          }
          else
          {
            return 1;
          }
        }
      })
    },
    handleShapeImageMove (e, analysisShape) {
      this.dragObj = $$(e.target)
      this.dragAnalysisShape = analysisShape
      // 鼠标点击位置横坐标
      this.gapX = event.clientX - this.dragObj.offset().left
      // 鼠标点击位置纵坐标
			this.gapY = event.clientY - this.dragObj.offset().top
      //movemove事件必须绑定到$(document)上，鼠标移动是在整个屏幕上的
			$$(document).bind("mousemove", this.handleMouseMove);
			//此处的$(document)可以改为obj
			$$(document).bind("mouseup", this.handleMouseStop);
    },
    handleMouseMove (event) {
      this.dragObj.css({
				"left": (event.clientX - this.gapX - this.divRec.left) + "px",
				"top": (event.clientY - this.gapY - this.divRec.top) + "px"
			});
			return false;
    },
    handleMouseStop () {
      $$(document).unbind("mousemove", this.handleMouseMove);
			$$(document).unbind("mouseup", this.handleMouseStop);
    },
    handleDivImageShowMouseMove (e) {
      if (this.cdr == 1 && e.currentTarget && e.currentTarget == e.target) {
        // 首先清空所有已被选中的图形的选中效果
        var startTop=e.pageY;
  	    var startLeft=e.pageX;
        var selectBox = $$('<div id="select-box"></div>');
    		$$('body').append(selectBox);
    		selectBox.css({'position':'absolute', 'top':startTop+'px', 'left':startLeft+'px', 'background':'rgba(255,106,23,0.3)', 'transition':'all 0s', 'width':0, 'height':0, 'z-index':10})
        var that = this
        var clearSelected = true
        $$(document).on("mousemove", function (ev) {
          if (this.cdr == 0) {
            return
          }
          if (clearSelected) {
            that.fnClearSelectedShape()
            clearSelected = false
          }
          ev.preventDefault();
          var endTop = ev.pageY
  	      var endLeft = ev.pageX
          that.fnPositionSelectBox(selectBox, startTop, startLeft, endTop, endLeft)
        })
        $$(document).on('mouseup',function () {
          that.fnCheckImageSelectedByArea(selectBox)
          that.$nextTick(() => {
            $$('#select-box').remove();
      		  $$(document).unbind('mousemove');
      		  $$(document).unbind('mouseup');
          })
    		})
      }
    },
    fnCheckImageSelectedByArea (selectBox) {
      this.analysisShapeInfo.analysisShapeInfos.forEach(shape => {
        var imgObj = $$("#" + shape.staticID)
        var imgTop = imgObj.offset().top
        var imgLeft = imgObj.offset().left
        if (selectBox.offset().left <= imgObj.offset().left && selectBox.offset().top <= imgObj.offset().top
          && selectBox.offset().left + selectBox.width() >= imgObj.offset().left + imgObj.width()
          && selectBox.offset().top + selectBox.height() >= imgObj.offset().top + imgObj.height()) {
          shape.selected = 1
          imgObj.css({
            "border": "1px solid blue"
          })
        } else {
          shape.selected = 0
          imgObj.css({
            "border": "0px solid blue"
          })
        }
      })
      // console.log('Selected ShapeInfos', this.analysisShapeInfo.analysisShapeInfos.filter(sh => sh.selected == 1))
    },
    fnPositionSelectBox (selectBox, startTop, startLeft, endTop, endLeft) {
      if(endTop-startTop>0 && endLeft-startLeft>0){
  			var height=endTop-startTop;
  			var width=endLeft-startLeft;
  			selectBox.css({
  			  'width':width+'px',
  			  'height':height+'px'
  			})
  		  }else if(endTop-startTop<0 && endLeft-startLeft<0) {
  			var height=-(endTop-startTop);
  			var width=-(endLeft-startLeft);
  			selectBox.css({
  			  'width':width+'px',
  			  'height':height+'px',
  			  'top':endTop+'px',
  			  'left':endLeft+'px'
  			})
  		  }else if(endTop-startTop>0 && endLeft-startLeft<0) {
  			var height=(endTop-startTop);
  			var width=-(endLeft-startLeft);
  			selectBox.css({
  			  'width':width+'px',
  			  'height':height+'px',
  			  'top':startTop+'px',
  			  'left':endLeft+'px'
  			})
  		  }else if(endTop-startTop<0 && endLeft-startLeft>0) {
  			var height=-(endTop-startTop);
  			var width=(endLeft-startLeft);
  			selectBox.css({
  			  'width':width+'px',
  			  'height':height+'px',
  			  'top':endTop+'px',
  			  'left':startLeft+'px'
  			})
		  }
    },
    fnClearSelectedShape () {
      // 清空已选中的图形
      this.analysisShapeInfo.analysisShapeInfos.forEach(shape => {
        shape.selected = 0
        $$("#" + shape.staticID).css({
          "border": "0px solid blue"
        })
      })
    },
    initShapeColumns () {
      this.shapeColumns = [...shapeInfoColumns]
      this.schemeInfo.productOptions.forEach((opt, index) => {
        const column = {
          title: '可选规格' + (index + 1) + ':' + opt.optionName + '(' + (opt.optionType == 2 ? '多选' : '单选') + ')',
          dataIndex: opt.id,
          key: 'opt' + opt.id,
          width: 400,
          scopedSlots: { customRender: 'opt' + opt.id, title: 'opt' + opt.id }
        }
        this.scroll.x += 400
        this.shapeColumns.push(column)
      })
    },
    handleShapeProdImageClicked (shape, option, addition) {
      if (addition.selected) {
        return
      } else {
        shape.additions.filter(add => add.optionId == option.optionId).forEach(add => {
          add.selected = 0
        })
        addition.selected = 1
      }
    },
    handleShapeProdLiClicked (shape, option, addition) {
      if (addition.selected) {
        addition.selected = 0
      } else {
        addition.selected = 1
      }
    },
    handleOptionImageClicked (record, addition) {
      if (addition.selected) {
        return
      }
      record.additions.forEach(add => {
        add.selected = 0
      })
      addition.selected = 1
    },
    handleOptionLiClicked (record, addition) {
      if (addition.selected) {
        addition.selected = 0
      } else {
        addition.selected = 1
      }
    },
    handleBtnSchemeOptionResetClicked () {
      this.schemeOptions.forEach(opt => {
        opt.additions.forEach(add => {
          if (add.isDefault == 1) {
            add.selected = 1
          } else {
            add.selected = 0
          }
        })
      })
      // console.log('this.schemeOptions===>', this.schemeOptions)
    },
    handleBtnShapeTableResetClicked () {
      this.analysisShapeInfo.analysisShapeInfos.forEach(shapeInfo => {
        var defaultProduct = this.schemeInfo.aiSchemeProds.find(content => content.isDefault == 1)
        if (defaultProduct) {
          this.handleShapeProductChanged(defaultProduct, shapeInfo)
        } else {
          shapeInfo.productType = '-1'
          shapeInfo.productName = ''
          shapeInfo.additions = []
        }
      })
    },
    shapesTableCustomRow (record) {
      return {
        on: { // 事件
          click: (event) => {
            var rec = this.selectedRows.find(r => r.staticID == record.staticID)
            if (rec) {
              this.selectedRows = [...this.selectedRows.filter(r => r.staticID != record.staticID)]
              this.selectedRowKeys = [...this.selectedRowKeys.filter(key => key != record.staticID)]
            } else {
              this.selectedRows.push(record)
              this.selectedRowKeys.push(record.staticID)
            }
          }
        }
      }
    },
    handleBtnGetPricingClicked () {
      // console.log('this.selectedRows===>', this.selectedRows)
      if (this.selectedRows == null || this.selectedRows.length == 0) {
        Toast('请选择要报价的产品')
        return
      }
      var flag = true
      this.selectedRows.every(row => {
        flag = row.productType != '-1'
        return flag
      })
      if (!flag) {
        Toast('选中图形中，有未设置产品的图形，请查看。')
        return;
      }
      var orderbo = this.convertToDesignOrderTreeBo()
      // console.log("handleBtnGetPricingClicked orderbo===>", orderbo)
      var param = {
        in: JSON.stringify(orderbo),
        appId: 'APP_XMPC',
        saasFactoryId: this.schemeInfo.saasFactoryId,
        saasProjectId: this.schemeInfo.saasProjectId
      }
      this.$store.dispatch('scheme/designPrice', param)
        .then(res => {
          if (res.data && res.data.retCode == 1) {
            localStorage.setItem("designOrderJson", JSON.stringify(res.data.obj));
            this.$router.push({
              path: '/preview',
              name: 'AI报价预览',
              params: {'designOrderJson': res.data.obj}
            })
          } else {
            Toast('获取报价失败')
          }
        }).catch(err => {
          console.log('err===>', err)
        })
    },

    convertToDesignOrderTreeBo () {
      // 报价信息主表
      var orderbo = {
        id: '',
        orderNum: '',
        projectName: this.projectName,
        companyName: this.companyName,
        companyId: this.companyId,
        factoryId: this.schemeInfo.saasFactoryId,
        userId: '',
        userName: '',
        imageUrl: this.analysisShapeInfo.imageUrl,
        imageLocalPath: this.analysisShapeInfo.imagePath,
        orderSource: 0,
        priceState: 0,
        uploadState: 0,
        isDelete: 0,
        createTime: '',
        uploadTime: '',
        money: 0,
        productMoneyNum: this.analysisShapeInfo.analysisShapeInfos.length,
        productAllNum: this.analysisShapeInfo.analysisShapeInfos.length,
        productTypeNum: this.analysisShapeInfo.analysisShapeInfos.length,
        remark: '',
        isCreateOrder: 0,
        imageIsUpload: 1,
        createDateStr: '',
        cdrUrl: this.cdrFileInfo.cdrFileUrl,
        cdrName: this.cdrFileInfo.cdrFileName,
        difMoney: 0,
        custId: '-1',
        custName: '',
        linkId: '-1',
        psfsId: '-1',
        zffsId: '-1',
        xdsj: '',
        jhsj: '',
        fileIsUpload: 1,
        isCreateBjd: 0,
        bjdId: '-1',
        bjdNum: '',
        isCreateDd: 0,
        ddId: '-1',
        ddNum: '',
        prepaidMoney: 0,
        content: this.requirement,
        moneyChange: 0,
        projectId: this.schemeInfo.projectId,
        cdrFileDirPath: this.cdrFileInfo.cdrFilePath,
        ccProdTypeId: this.ccProdTypeId,
        ccProdTypeName: this.ccProdTypeName,
        childDesignOrderDetails: [],
        designOrderAdditionOrtherList: [],
        designOrderGroupList: [],
        priceType: 0
      }
      // 报价信息产品信息
      var quoShapes = [...this.selectedRows]
      this.fnSortShapeInfo(quoShapes)
      quoShapes.forEach(shapeInfo => {
        orderbo.childDesignOrderDetails.push(this.convertDesignOrderDetail(orderbo.id, shapeInfo))
      })
      // 报价信息附加项
      this.schemeInfo.schemeOptions.forEach(opt => {
        opt.additions.forEach(add => {
          if (add.selected == 1) {
            orderbo.designOrderAdditionOrtherList.push(this.convertDesignOrderAddition(orderbo.id, add))
          }
        })
      })
      return orderbo
    },
    convertDesignOrderDetail (orderId, shapeInfo) {
      var msWidth = shapeInfo.shapeWidth * shapeInfo.sizeMult / 10
      var msHeight = shapeInfo.shapeHeight * shapeInfo.sizeMult / 10
      var designOrderDetail = {
        id: '',
        designOrderId: orderId,
        msId: shapeInfo.staticID,
        msName: '曲线',
        msType: '3',
        msWidth: msWidth,
        msHeight: msHeight,
        msPerimeter: shapeInfo.msPerimeter ? shapeInfo.msPerimeter / 10 : (msWidth + msHeight) * 2,
        msArea: shapeInfo.msArea ? (shapeInfo.msArea * shapeInfo.sizeMult * shapeInfo.sizeMult)  / 1000000 : msWidth * msHeight / 10000,
        msDirPath: shapeInfo.imagePath,
        msImageUrl: shapeInfo.imageUrl,
        msText: '',
        msParentId: '-1',
        parentId: '-1',
        proType: '0',
        upTypeId: '',
        proId: shapeInfo.productType,
        prodName: shapeInfo.productName,
        isJoinPrice: 1,
        price: '',
        unitPrice: '',
        num: 1,
        allPrice: 0,
        childPrice: '',
        imageIsUpload: 1,
        isDelete: 0,
        additionOnePrice: 0,
        additionAllPrice: 0,
        prodAllPrice: 0,
        isUserPrice: 0,
        isUserSpec: 0,
        roundFormat: '0.00',
        roundModel: '4',
        discount: 1,
        difMoney: 0,
        addDifMoney: 0,
        degree: 0,
        isGroup: 0,
        mark: '',
        productCycle: 1,
        shapeLeftX: shapeInfo.leftx,
        shapeRightX: shapeInfo.rightx,
        shapeTopY: shapeInfo.topy,
        shapeBottomY: shapeInfo.bottomy,
        craftDiscription: ''
      }
      this.getDesignOrderDetailSpec(designOrderDetail, shapeInfo)
      var designOrderAdditions = this.convertOrderDetailAdditions(shapeInfo, designOrderDetail)
      designOrderDetail.designOrderAdditions = designOrderAdditions
      return designOrderDetail
    },
    convertDesignOrderAddition (orderId, add) {
      return {
        id: '',
        additionId: add.additionId,
        additionName: add.additionName,
        optionId: add.optionId,
        optionName: add.optionName,
        designOrderId: orderId,
        allPrice: 0,
        factoryId: this.schemeInfo.saasFactoryId,
        companyId: this.companyId,
        isDelete: 0,
        difMoney: 0,
        isDiscount: 0,
        additionNum: add.additionNum && add.additionNum > 1 ? add.additionNum : 1,
        additionPrice: 0,
        unit: 3,
        remark: ''
      }
    },
    convertOrderDetailAdditions (shapeInfo, designOrderDetail) {
      var designOrderAdditions = []
      if (shapeInfo.additions && shapeInfo.additions.length > 0) {
        var additionNum = 0
        shapeInfo.additions.forEach(add => {
          if (add.selected) {
            var designOrderAddition = {
              id: '',
              additionId: add.additionId,
              additionName: add.additionName,
              optionName: add.optionName,
              optionId: add.optionId,
              // priceType: 0,
              // priceMethod: designOrderDetail.priceType,
              unit: designOrderDetail.priceUnit,
              unitName: designOrderDetail.priceUnitName,
              designOrderId: designOrderDetail.designOrderId,
              designDetailId: designOrderDetail.id,
              cdrSpec: 0,
              spec: designOrderDetail.spec,
              unitPrice: 0,
              allPrice: 0,
              factoryId: this.schemeInfo.saasFactoryId,
              companyId: this.companyId,
              isDelete: 0,
              difMoney: 0,
              additionNum: add.additionNum && add.additionNum > 1 ? add.additionNum : 1,
              isDiscount: 0
            }
            designOrderAdditions.push(designOrderAddition)
            additionNum += designOrderAddition.additionNum
          }
        })
        designOrderDetail.additionNum = additionNum
      }
      return designOrderAdditions
    },
    getDesignOrderDetailSpec (designOrderDetail, shapeInfo) {
      if (shapeInfo.shapeWidth * shapeInfo.sizeMult > 1000 && shapeInfo.shapeHeight * shapeInfo.sizeMult > 1000) {
        designOrderDetail.spec = designOrderDetail.msArea
        designOrderDetail.priceTypeName = '长*宽计价'
        designOrderDetail.priceType = 3
        designOrderDetail.priceUnitName = '平米'
        designOrderDetail.priceUnit = 4
      } else {
        designOrderDetail.spec = shapeInfo.shapeWidth >= shapeInfo.shapeHeight ? (shapeInfo.shapeWidth * shapeInfo.sizeMult) / 10 : (shapeInfo.shapeHeight * shapeInfo.sizeMult) / 10
        designOrderDetail.priceTypeName = '长宽长者计价'
        designOrderDetail.priceType = 1
        designOrderDetail.priceUnitName = '厘米'
        designOrderDetail.priceUnit = 1
      }
    },
    handleBtnTestCdrCorsClicked () {

    },
    fnUpdateReleaseReoprtByCompanyId () {
      var param = { companyId: this.schemeInfo.companyId, aiQuotationNum: 1 }
      this.$store.dispatch('ccReleaseReport/updateReleaseReoprtByCompanyId', JSON.stringify(param))
        .then(res => {
          // console.log('fnUpdateReleaseReoprtByCompanyId res ===>', res)
        }).catch(err => {
          console.log('err===>', err)
        })
    }
  },
  mounted () {
    document.title = "AI智能报价"
    // 更新AI报价点击次数
    this.fnUpdateReleaseReoprtByCompanyId()
    if (!this.analysisShapeInfo || !this.analysisShapeInfo.analysisShapeInfos || this.analysisShapeInfo.analysisShapeInfos.length <= 0) {
      this.fnGetDpi()
      this.initSchemeInfo()
    }
  },
  created () {

  }
}
const shapeInfoColumns = [
  {
    title: '序号',
    dataIndex: 'serial',
    key: 'serial',
    width: 60,
    fixed: 'left',
    scopedSlots: { customRender: 'serial' }
  },
  {
    title: '图形',
    dataIndex: 'image',
    key: 'image',
    width: 200,
    fixed: 'left',
    scopedSlots: { customRender: 'image' }
  },
  {
    title: '尺寸(厘米)',
    dataIndex: 'size',
    key: 'size',
    width: 150,
    fixed: 'left',
    scopedSlots: { customRender: 'size' }
  },
  {
    title: '制作产品类',
    dataIndex: 'product',
    key: 'product',
    width: 350,
    fixed: 'left',
    scopedSlots: { customRender: 'product' }
  }
]

const optionColumns = [
  {
    title: '序号',
    dataIndex: 'serial',
    key: 'serial',
    scopedSlots: { customRender: 'serial' }
  }, {
    title: '规格',
    dataIndex: 'optionName',
    key: 'optionName',
    scopedSlots: { customRender: 'optionName' }
  }, {
    title: '选项',
    dataIndex: 'optionDetail',
    key: 'optionDetail',
    scopedSlots: { customRender: 'optionDetail' }
  }
]



// WEBPACK FOOTER //
// ./src/pages/product/cdrConvert.vue